export class BvaProviders {
  intended: any;
  recommended: Array<any>;

  constructor(obj?) {
    this.intended = obj && obj.intended ? obj.intended : {};
    this.recommended = obj && obj.recommended ? obj.recommended : [];
  }
}
